import { ChangeDetectorRef, Component, Input, OnInit, OnChanges, OnDestroy, ViewChild, ViewEncapsulation, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { QnSbnService } from '../services/qn-sbn-service.service';
import { EmailDeliveryDetailsComponent } from '../email-delivery-details/email-delivery-details.component';
import { OneWebComponentsAngularModule } from '@one/angular';
import { AppUtils } from '../utlis/app-utils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dl-email-delivery-table',
  standalone: true,
  imports: [OneWebComponentsAngularModule, CommonModule, ReactiveFormsModule, FormsModule, EmailDeliveryDetailsComponent],
  templateUrl: './email-delivery-table.component.html',
  styleUrls: ['./email-delivery-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class EmailDeliveryTableComponent implements OnInit, OnChanges, OnDestroy {

  @Input() emailTableData = [];
  dataSource: any[] = [];
  filteredData: any[] = [];
  paginatedData: any[] = [];
  

  currentPage = 0;
  pageSize = 10; 
  pageSizeOptions = [10, 25, 50, 100, 250, 500];
  totalCount = 0;
  
 
  sortColumn = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  
  displayedColumns = ['Country', 'Id', 'Name', 'Email', 'Date', 'Resend', 'Status'];
  searchBox = new FormControl('');
  searchValue = '';
  
  private searchSubscription: Subscription = new Subscription();
  
  // Modal properties
  emailData: { MessageId: any; CustomerContactEmail: any; };
  visible: boolean = false;

  constructor(
    public appUtils: AppUtils,
    public changeDetectorRef: ChangeDetectorRef,
    public qnsbnService: QnSbnService
  ){}

  ngOnChanges(){
    if (this.emailTableData && Array.isArray(this.emailTableData)) {
      this.dataSource = [...this.emailTableData];
      this.filteredData = [...this.dataSource];
      this.totalCount = this.dataSource.length;
      this.updatePaginatedData();
     
    } else {
     
      this.dataSource = [];
      this.filteredData = [];
      this.paginatedData = [];
      this.totalCount = 0;
    }
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    if (this.emailTableData && Array.isArray(this.emailTableData) && this.emailTableData.length > 0) {
      this.dataSource = [...this.emailTableData];
      this.filteredData = [...this.dataSource];
      this.totalCount = this.dataSource.length;
      this.updatePaginatedData();
    }

   
    this.searchSubscription = this.searchBox.valueChanges.subscribe(value => {
      this.searchText(value || '');
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  updatePaginatedData(): void {
    if (this.sortColumn) {
      this.applySort();
    }
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedData = this.filteredData.slice(startIndex, endIndex);
   
    this.paginatedData.forEach((item, index) => {
     
    });
  }

  applySort(): void {
    if (!this.sortColumn) {
      return;
    }

    this.filteredData.sort((a, b) => {
      const aVal = this.getSortValue(a, this.sortColumn);
      const bVal = this.getSortValue(b, this.sortColumn);
      
      let comparison = 0;
      if (aVal! > bVal!) {
        comparison = 1;
      } else if (aVal! < bVal!) {
        comparison = -1;
      }
      
      return this.sortDirection === 'desc' ? comparison * -1 : comparison;
    });
  }

  getSortValue(data: any, sortHeaderId: string): any {
    switch (sortHeaderId) {
      case 'Id': return data.CustomerId;
      case 'Name': return data.CustomerName;
      case 'Country': return data.Country;
      case 'Email': return data.CustomerContactEmail;
      case 'Date': return new Date(data.Date);
      case 'Resend': return data.IsResend;
      case 'Status': return data.DeliveryStatus;
      default: return data[sortHeaderId];
    }
  }

  onSort(column: string, direction: string): void {
    this.sortColumn = column;
    this.sortDirection = direction as 'asc' | 'desc';
    this.updatePaginatedData();
  }

  clearSearch(): void {
    this.searchBox.setValue('');
    this.searchValue = '';
    this.performFilter('');
  }

  searchText(searchValue: string): void {
    this.searchValue = searchValue;
    this.performFilter(searchValue);
  }

  performFilter(filterValue: string): void {
    const searchStr = filterValue.trim().toLowerCase();
    
    if (!searchStr) {
      this.filteredData = [...this.dataSource];
    } else {
      this.filteredData = this.dataSource.filter((data: any) => {
        return this.appUtils.getLowerCase(data.Date).includes(searchStr) 
        || this.appUtils.getLowerCase(data.Country).includes(searchStr) 
        || this.appUtils.getLowerCase(data.CustomerContactEmail).includes(searchStr) 
        || this.appUtils.getLowerCase(data.CustomerId).includes(searchStr) 
        || this.appUtils.getLowerCase(data.DeliveryStatus).includes(searchStr) 
        || this.appUtils.getLowerCase(data.CustomerName).includes(searchStr) 
        || this.appUtils.getLowerCase(data.IsResend).includes(searchStr);
      });
    }
    
    this.currentPage = 0;
    this.totalCount = this.filteredData.length;
    this.updatePaginatedData();
    this.changeDetectorRef.detectChanges();
  }



  get totalPages(): number {
    return Math.ceil(this.totalCount / this.pageSize);
  }

  get startIndex(): number {
    return this.currentPage * this.pageSize + 1;
  }

  get endIndex(): number {
    return Math.min((this.currentPage + 1) * this.pageSize, this.totalCount);
  }

  getColumnLabel(column: string): string {
    const labels: { [key: string]: string } = {
      'Country': 'Country',
      'Id': 'Customer ID',
      'Name': 'Customer Name',
      'Email': 'Email',
      'Date': 'Date',
      'Resend': 'Resend',
      'Status': 'Status'
    };
    return labels[column] || column;
  }

   emailDetails(row: any): void {
    this.emailData = { 
      MessageId: row?.MessageId, 
      CustomerContactEmail: row?.CustomerContactEmail 
    };
    this.visible = true;
   
  }

  onDialogClose(event: any): void {
   
    this.visible = false;
  }

  trackByFn(index: number, item: any): any {
    return item.CustomerId || index;
  }

  getDeliveryStatusClass(status: string): string {
    switch(status) {
      case 'Delivered':
        return 'delivered-status';
      case 'Failed':
        return 'failed-status';
      default:
        return '';
    }
  }

  // Simple Pagination methods
  goToPreviousPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.updatePaginatedData();
      this.changeDetectorRef.detectChanges();
    }
  }

  goToNextPage(): void {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
      this.updatePaginatedData();
      this.changeDetectorRef.detectChanges();
    }
  }

  goToFirstPage(): void {
    this.currentPage = 0;
    this.updatePaginatedData();
    this.changeDetectorRef.detectChanges();
  }

  goToLastPage(): void {
    this.currentPage = this.totalPages - 1;
    this.updatePaginatedData();
    this.changeDetectorRef.detectChanges();
  }

  onPageSizeChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    this.pageSize = parseInt(target.value);
    this.currentPage = 0; 
    this.updatePaginatedData();
    this.changeDetectorRef.detectChanges();
  }

}
